import { render, staticRenderFns } from "./DownloadQRAction.vue?vue&type=template&id=0cd4913d&scoped=true&"
import script from "./DownloadQRAction.vue?vue&type=script&lang=js&"
export * from "./DownloadQRAction.vue?vue&type=script&lang=js&"
import style0 from "./DownloadQRAction.vue?vue&type=style&index=0&id=0cd4913d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd4913d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VContainer})
